module.exports = __webpack_public_path__ + "images/super-model-2f03df89ff5daa5802edea215f432c84.png";